import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

const ModalContainer = styled.div<{ theme: ThemeType }>`
  padding: 24px;
  .campos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  .botoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 3rem;
    margin-top: 3rem;
    .cancelar {
      cursor: pointer;
    }
  }
`;

export { ModalContainer };
